import { createStyles, makeStyles, Theme } from '@material-ui/core';

const MediaExportStyles = makeStyles(({ palette, spacing }: Theme) => createStyles({
  root: {

  },
  closeButton: {
    position: 'absolute',
    right: spacing(1),
    top: spacing(1),
    color: palette.grey[500],
  },
  noselect: {
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
  },
}), { name: 'MediaExportStyles' });

export default MediaExportStyles;
